import script from "./CompanyProfile.vue?vue&type=script&setup=true&lang=js"
export * from "./CompanyProfile.vue?vue&type=script&setup=true&lang=js"

import "./CompanyProfile.vue?vue&type=style&index=0&id=29ed8a98&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-29ed8a98"]])

export default __exports__